import comp from "./ConditionalTooltip";

export default comp;
